/* eslint-disable react/no-array-index-key */
import React from 'react'
import { shape, arrayOf } from 'prop-types'


const CMSModules = ({
  contents = [], cmsComponents, className, ...rest
}) => contents.map((zoneData, index) => {
  const {
    type, configs, name, moduleId,
  } = zoneData
  const Component = cmsComponents[type]

  if (!Component) {
    return null
  }

  return (
    <Component
      moduleData={configs}
      {...rest}
      name={name}
      moduleId={moduleId}
      type={type}
      key={`${type}-${index}`}
      modules={cmsComponents}
      className={className}
    />
  )
})

CMSModules.propTypes = {
  cmsComponents: shape({}),
  contents: arrayOf(shape({})),
}

export default CMSModules



// WEBPACK FOOTER //
// ./components/cms/CMSModules.js